import axios from "axios";

export const fetchQueryParentCompanies = async (data: any) => {
  const path = "/api/parentcompany";
  const query = `?companyName=${data.companyName ?? ""}&organizationName=${data.organizationName ?? ""}`;
  const paging = `&pageSize=${data.pageSize}&pageNumber=${data.pageNumber}`;
  const url = `${path}${query}${paging}`;
  return await axios.get(url);
};
